// Main navigation

$(function () {
  const event = $(window).width() > 991 ? 'mouseover' : 'click';

  $('.MainNavigation-uglyMenu .dropdown-toggle').on(event, function (e) {
    e.stopPropagation();
    e.preventDefault();
    $('.MainNavigation-uglyMenu .dropdown-menu').removeClass('show');
    $(this).next('.dropdown-menu').addClass('show');
  });

  $(window).on('load resize', function () {
    const $collapsible = $('.jsCollapsible');
    if ($(window).width() > 991) {
      $collapsible.addClass('collapse');
    } else {
      $collapsible.removeClass('collapse');
    }
  });
});
